'use strict';

import FilterSlidable from "../ui/filter/FilterSlidable";
import CheckboxList from "../ui/filter/CheckboxList";
import Select from "../ui/filter/Select";
import Switch from "../ui/filter/Switch";
import Range from "../ui/filter/Range";
import Loading from "../Loading";
import { TYPES } from "../../hooks/useSearchFilters";


export default function Filters({filters = [], values = {}, isLoading = false, error = undefined, onChange, onReload}) {
    function clearFilters() {
        onChange({})
    }

    function setFilter({filter_id, filter_type, id, value, from, to}) {
        const filter = filters.find(e => e.id === filter_id)
        if (!filter)
            return;
        
        let filterValue = values[filter_id] || undefined;

        switch (filter_type) {
            case TYPES.CHECKBOX:
                filterValue = filterValue || []
                
                if (value)
                    filterValue.push(id);
                else
                    filterValue = filterValue.filter(e => e !== id)
                break;
            case TYPES.RADIO:
                if (value)
                    filterValue = id;
                else
                    filterValue = undefined
                break;
            case TYPES.SELECT:
                filterValue = value;
                break;
            case TYPES.SWITCH:
                filterValue = value ? 1 : undefined;
                break;
            case TYPES.RANGE:
                filterValue = filterValue || { from: '', to: '' };
                filterValue.from = from !== undefined ? from : filterValue.from;
                filterValue.to = to !== undefined ? to : filterValue.to;
                break;
        }

        onChange({...values, [filter_id]: filterValue})
    }

    function isFilterItemSelected({filter_id, filter_type, id, from, to}) {
        const filter = filters.find(e => e.id === filter_id)
        if (!filter) 
            return false;

        if (values[filter_id] === undefined)
            return false;

        switch (filter_type) {
            case TYPES.CHECKBOX:
                return !!values[filter_id].includes(id);
            case TYPES.SELECT:
            case TYPES.RADIO:
                return values[filter_id] === id
            case TYPES.SWITCH:
                return !!values[filter_id]
            case TYPES.RANGE:
                if (from !== undefined)
                    return values[filter_id].from !== undefined;
                if (to !== undefined)
                    return values[filter_id].to !== undefined;
        }

        return false;
    }

    function getFilterItemRangeValue({filter_id, from = false, to = false}) {
        const filter = filters.find(e => e.type === TYPES.RANGE && e.id === filter_id)
        if (!filter || values[filter_id] === undefined) return '';

        if (from) return values[filter_id].from
        if (to) return values[filter_id].to
        return ''
    }

    function getFilterItemSelectValue({filter_id}) {
        const filter = filters.find(e => e.type === TYPES.SELECT && e.id === filter_id)
        if (!filter || values[filter_id] === undefined) return '';

        return values[filter_id];
    }

    function filterHasValues(id) {
        const filter = filters.find(e => e.id === id)
        if (!filter || values[filter.id] === undefined) return false;
        
        if (Array.isArray(values[filter.id])) {
            return values[filter.id].length > 0;
        } else {
            return !!values[filter.id] 
                || !!values[filter.id].from
                || !!values[filter.id].to
        }
    }

    function clearFilterById(id) {
        const filter = filters.find(e => e.id === id)
        if (!filter) return;
        
        const newValues = {...values}
        if (id in newValues) {
            delete newValues[id]
        }
        
        onChange(newValues)
    }

    return <React.Fragment>
        
        {<Loading active={isLoading} absolute={false} styleContainer={{padding:'20px 0'}} style={{width:'50px',height:'50px'}}/>}
        {!isLoading && error && <div style={{textAlign:'center',margin:'30px 0px'}}>{error}</div>}
        {!isLoading && !error && filters.length === 0 && <div style={{textAlign:'center',margin:'30px 0px'}}>{'No filters'}</div>}
        
        {!isLoading && !error && filters.map(({id, type, title, fromTitle, toTitle, values: items, count}, index) => {
            const key_prefix = `${type}-${id}-`
            const data = {filter_id: id, filter_type: type};

            switch (type) {
                case TYPES.CHECKBOX:
                    return <FilterSlidable key={key_prefix}
                                           title={title} 
                                           isOpenedInit={index === 0}
                                           showClear={filterHasValues(id)}
                                           onClear={() => clearFilterById(id)}>
                        <CheckboxList
                            type={TYPES.CHECKBOX}
                            keyPrefix={key_prefix}
                            items={items}
                            isChecked={({id}) => isFilterItemSelected({...data, id})}
                            onChange={({id, value}) => setFilter({...data, id, value})}
                        />
                    </FilterSlidable>

                case TYPES.RADIO:
                    return <FilterSlidable key={key_prefix} 
                                           title={title}
                                           isOpenedInit={index === 0}
                                           showClear={filterHasValues(id)}
                                           onClear={() => clearFilterById(id)}>
                        <CheckboxList
                            type={TYPES.RADIO}
                            keyPrefix={key_prefix}
                            items={items}
                            isChecked={({id}) => isFilterItemSelected({...data, id})}
                            onChange={({id, value}) => setFilter({...data, id: id, value: value})}
                        />
                    </FilterSlidable>

                case TYPES.SELECT:
                    return <FilterSlidable key={key_prefix} 
                                           title={title}
                                           isOpenedInit={index === 0}
                                           showClear={filterHasValues(id)}
                                           onClear={() => clearFilterById(id)}>
                        <Select
                            keyPrefix={key_prefix}
                            items={items.filter(e => e.count > 0)}
                            value={getFilterItemSelectValue({...data})}
                            onChange={(value) => setFilter({...data, value})}
                            selectClass={"el-selectbox"}
                            dropdownClass={'el-drop'}
                            required={true}
                            hideSelectedOption={true}
                            escapeMarkup={true}
                            formatListOptionCode={'sidebarCountPrice'}
                        />
                    </FilterSlidable>

                case TYPES.SWITCH:
                    const item = items.find(e => e.id.toString() === '1')
                    return <Switch
                        key={key_prefix}
                        title={title}
                        count={item.count}
                        disabled={item.count === 0}
                        checked={isFilterItemSelected({...data, id})}
                        onChange={(value) => {
                            setFilter({...data, value})
                        }}
                    />

                case TYPES.RANGE:
                    return <FilterSlidable key={key_prefix} 
                                           title={title}
                                           isOpenedInit={index === 0}
                                           showClear={filterHasValues(id)}
                                           onClear={() => clearFilterById(id)}>
                        <Range
                            titleFrom={fromTitle}
                            titleTo={toTitle}
                            valueFrom={getFilterItemRangeValue({...data, from: true})}
                            valueTo={getFilterItemRangeValue({...data, to: true})}
                            onChangeFrom={(value) => {
                                setFilter({...data, from: value})
                            }}
                            onChangeTo={(value) => {
                                setFilter({...data, to: value})
                            }}
                        />
                    </FilterSlidable>
            }
        })}
        <div className="el__filter-reset">
            {!error && filters.length > 0 && <button className="el__filter-reset-btn" onClick={clearFilters}>
                {tMsg('Сбросить фильтр')}
            </button>}
            {error && <button className="el__filter-reset-btn" onClick={onReload}>
                {tMsg('Обновить')}
            </button>}
        </div>
    </React.Fragment>
}
